import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconFolderProject = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M8 14.25C7.58579 14.25 7.25 14.5858 7.25 15C7.25 15.4142 7.58579 15.75 8 15.75H16C16.4142 15.75 16.75 15.4142 16.75 15C16.75 14.5858 16.4142 14.25 16 14.25H8Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6 3.25C3.92893 3.25 2.25 4.92893 2.25 7V17C2.25 19.0711 3.92893 20.75 6 20.75H18C20.0711 20.75 21.75 19.0711 21.75 17V9C21.75 6.92893 20.0711 5.25 18 5.25H12.1575C11.6152 5.25 11.2887 4.90524 10.9609 4.53061C10.2488 3.7168 9.22005 3.25 8.1387 3.25H6ZM3.75 7C3.75 5.75736 4.75736 4.75 6 4.75H8.1387C8.97829 4.75 9.56661 5.21507 10.088 5.81089C10.6101 6.40768 11.3645 6.75 12.1575 6.75H18C19.2426 6.75 20.25 7.75736 20.25 9V17C20.25 18.2426 19.2426 19.25 18 19.25H6C4.75736 19.25 3.75 18.2426 3.75 17V7Z",
		fill: "currentColor"
	})]
});
export { SvgIconFolderProject as ReactComponent };
